import { render, staticRenderFns } from "./ExportNominationList.vue?vue&type=template&id=2249029a&scoped=true"
import script from "./ExportNominationList.vue?vue&type=script&lang=js"
export * from "./ExportNominationList.vue?vue&type=script&lang=js"
import style0 from "./ExportNominationList.vue?vue&type=style&index=0&id=2249029a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2249029a",
  null
  
)

export default component.exports